import React from 'react';
import { Mail, MapPin } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-[#222222] text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-start justify-items-center text-center md:text-left">
          <div className="w-full flex flex-col items-center md:items-start">
            <h2 className="text-2xl font-bold mb-6">FLEXORA</h2>
            <p className="text-gray-400 mb-6">
              {t('footer.description')}
            </p>
          </div>

          <div className="w-full flex flex-col items-center md:items-start">
            <h3 className="text-lg font-semibold mb-6">{t('footer.contact')}</h3>
            <ul className="w-full flex flex-row justify-between items-center space-y-0 space-x-4">
              <li className="flex items-center">
                <Mail className="w-5 h-5 mr-3 text-gray-400" />
                <a href="mailto:sb48@inbox.lv" className="text-gray-400 hover:text-white transition-colors">
                  sb48@inbox.lv
                </a>
              </li>
              <li className="flex items-center">
                <MapPin className="w-5 h-5 mr-3 text-gray-400" />
                <span className="text-gray-400">
                  Grīvas pr. 6-38,<br />
                  Ogre, LV-5001, Latvia
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-800 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} FLEXORA. {t('footer.rights')}</p>
          <p className="mt-2 text-sm">
            {t('footer.poweredBy')}{' '}
            <a 
              href="https://hedgedev.net" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-blue-400 hover:text-blue-300 transition-colors"
            >
              Hedge Dev
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;